import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[aaDashTabTitle]',
    standalone: false
})
export class DashTabTitleDirective
{
    constructor(public templateRef: TemplateRef<any>) { }
}
